<template>

    <Dialog v-model:visible="showDialog" modal :style="{ width: '750px' }" @hide="onHideDialog" header=" ">

        <!--
        Step 1 - view
        Step 2 - Add children: chose children type
        Step 3 - Edit type
        Step 4 - Edit properties
        -->
        <div v-if="nodeData.type === 'connector'" class="flex flex-column align-items-center mb-2">
            <i class="pi pi-share-alt" style="font-size: 2rem" />
        </div>
        <div v-if="nodeData.type === 'procedure'" class="flex flex-column align-items-center mb-2">
            <i class="pi pi-cog" style="font-size: 2rem" />
        </div>

        <template v-if="step === 1">

            <Fieldset legend="Node details">
                <template v-if="nodeData.type === 'connector' && nodeData.details && nodeData.details.logical_operation" class="mt-4">

                    <div class="grid">
                        <div class="col-3">Type:</div>
                        <div class="col-9"><b>{{nodeData.details.logical_operation}}</b></div>
                    </div>
                </template>
                <template  v-if="nodeData.type === 'procedure'">

                    <div v-if="nodeData.details.procedure === 'attribute' || nodeData.details.procedure === 'first_attribute' || nodeData.details.procedure === 'last_attribute'" class="grid">
                        <div class="col-3">Type:</div>
                        <div class="col-9"><b>Attribute</b></div>
                        <div class="col-3">Tag:</div>
                        <div class="col-9"><b>{{nodeData.details.tag_id}}</b></div>
                        <div class="col-3">Assessment:</div>
                        <div class="col-9"><b>{{nodeData.details.assessment_code}}</b></div>
                        <div class="col-3">Attribute:</div>
                        <div class="col-9"><b>{{getAttributeByCode(nodeData.details.attribute_code)?.label}}</b></div>
                        <div class="col-3">Operator:</div>
                        <div class="col-9"><b>{{translateOperator(nodeData.details.operator)}}</b></div>
                        <div class="col-3">Labels:</div>
                        <div class="col-9"><b>{{getAttributeValueFromCode(nodeData.details.attribute_code, nodeData.details.value)}}</b></div>
                        <div class="col-3" v-if="DateTime.fromISO(nodeData.details.value).isValid">Date:</div>
                        <div class="col-3" v-else >Value:</div>

                        <div v-if="DateTime.fromISO(nodeData.details.value).isValid" class="col-9">
                            <b>{{dateFormat(DateTime.fromISO(nodeData.details.value))}}</b>
                        </div>
                        <div v-else class="col-9">
                            <b>{{nodeData.details.value}}</b>
                        </div>

                    </div>
                    <div v-else-if="nodeData.details.procedure === 'assessment_date'" class="grid">
                        <div class="col-3">Type:</div>
                        <div class="col-9"><b>Assessment date</b></div>
                        <div class="col-3">Operator:</div>
                        <div class="col-9"><b>{{translateOperator(nodeData.details.operator)}}</b></div>
                        <div class="col-3">Value:</div>
                        <div class="col-9"><b>{{dateFormat(nodeData.details.value)}}</b></div>
                    </div>
                    <div v-else-if="nodeData.details.procedure === 'user_today_age'" class="grid">
                        <div class="col-3">Type:</div>
                        <div class="col-9"><b>User today age</b></div>
                        <div class="col-3">Operator:</div>
                        <div class="col-9"><b>{{translateOperator(nodeData.details.operator)}}</b></div>
                        <div class="col-3">Value:</div>
                        <div class="col-9"><b>{{nodeData.details.value}}</b> year(s)</div>
                    </div>
                    <div v-else-if="nodeData.details.procedure === 'assessment_user_age'" class="grid">
                        <div class="col-3">Type:</div>
                        <div class="col-9"><b>User age (at assessment time)</b></div>
                        <div class="col-3">Operator:</div>
                        <div class="col-9"><b>{{translateOperator(nodeData.details.operator)}}</b></div>
                        <div class="col-3">Value:</div>
                        <div class="col-9"><b>{{nodeData.details.value}}</b> year(s)</div>
                    </div>
                    <div v-else-if="nodeData.details.procedure === 'assessment_code'" class="grid">
                        <div class="col-3">Type:</div>
                        <div class="col-9"><b>Assessment code</b></div>
                        <div class="col-3">Operator:</div>
                        <div class="col-9"><b>{{translateOperator(nodeData.details.operator)}}</b></div>
                        <div class="col-3">Value:</div>
                        <div class="col-9"><b>{{nodeData.details.value}}</b></div>
                    </div>
                    <div v-else-if="nodeData.details.procedure === 'pass_fail'" class="grid">
                        <div class="col-3">Type:</div>
                        <div class="col-9"><b>Pass / Fail</b></div>
                        <div class="col-12">
                            <div class=" align-items-center justify-content-center" v-if="nodeData.details.value === '1'">
                                The Assessment must end in a <Tag severity="success" value="Pass">Pass</Tag>
                            </div>
                            <div class=" align-items-center justify-content-center" v-if="nodeData.details.value === '0'">
                                The Assessment must end in a <Tag severity="danger" value="Fail">Fail</Tag>
                            </div>
                        </div>

                    </div>
                    <div v-else-if="nodeData.details.procedure === 'user_profile'" class="grid">
                        <div class="col-3">Type:</div>
                        <div class="col-9"><b>User Profile</b></div>
                        <div class="col-12">
                            <div class=" align-items-center justify-content-center" v-if="nodeData.details.value === '1'">
                                The Assessment be a <Tag severity="success" value="User Profile"></Tag>
                            </div>
                            <div class=" align-items-center justify-content-center" v-if="nodeData.details.value === '0'">
                                The Assessment must not be a <Tag severity="danger" value="User profile"></Tag>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="nodeData.details.procedure === 'active_only_assessment'" class="grid">
                        <div class="col-3">Type:</div>
                        <div class="col-9"><b>Active only Assessment</b></div>
                        <div class="col-12">
                            <div class=" align-items-center justify-content-center" v-if="nodeData.details.value === '1'">
                                The Assessment must be <Tag severity="success" value="Active"></Tag>
                            </div>
                            <div class=" align-items-center justify-content-center" v-if="nodeData.details.value === '0'">
                                The Assessment must be <Tag severity="danger" value="Inactive"></Tag>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="nodeData.details.procedure === 'active_only_attribute'" class="grid">
                        <div class="col-3">Type:</div>
                        <div class="col-9"><b>Active only Attribute</b></div>
                        <div class="col-12">
                            <div class=" align-items-center justify-content-center" v-if="nodeData.details.value === '1'">
                                The Attribute must be <Tag severity="success" value="Active"></Tag>
                            </div>
                            <div class=" align-items-center justify-content-center" v-if="nodeData.details.value === '0'">
                                The Attribute must be <Tag severity="danger" value="Inactive"></Tag>
                            </div>
                        </div>
                    </div>

                    <div v-else-if="nodeData.details.procedure === 'user_list'" class="grid">
                        <div class="col-3">Type:</div>
                        <div class="col-9"><b>Users list</b></div>
                        <div class="col-12">
                            <div v-if="step1UserLoading" class="ml-3">
                                <ProgressSpinner style="width: 25px; height: 25px" strokeWidth="8" fill="transparent"
                                                 animationDuration=".5s" aria-label="Custom ProgressSpinner" />
                                Loading Users...
                            </div>
                            <div v-else>
                                <DataTable
                                    :value="step1userList"
                                    paginator
                                    :rows="10"
                                    :totalRecords="step1userList.length"
                                    :lazy="false"
                                    responsiveLayout="scroll"
                                    ref="dt"
                                    data-key="id"
                                    :rowHover="true"
                                >
                                    <Column field="name" header="Name" style="max-width: 14rem" />
                                    <Column field="surname" header="Surname" style="max-width: 14rem" />
                                    <Column field="email" header="Email" style="max-width: 14rem" />
                                </DataTable>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="nodeData.details.procedure === 'archive_status'" class="grid">
                        <div class="col-3">Type:</div>
                        <div class="col-9"><b>Exclude archived, Archived only, Include all</b></div>

                        <div class="col-3">Value:</div>
                        <div class="col-9">
                            <Tag
                                v-if="nodeData.details.value == 1"
                                severity="success"
                                value="All users"
                            />
                            <Tag
                                v-else-if="nodeData.details.value == 2"
                                severity="success"
                                value="Exclude archived users (active only)"
                            />
                            <Tag
                                v-else-if="nodeData.details.value == 3"
                                severity="warning"
                                value="Archived users only"
                            />
                        </div>
                    </div>

                    <div v-else>
                        WIP: {{nodeData.details.procedure}}
                    </div>
                </template>

            </Fieldset>

        </template>

        <template v-if="step === 2">
            <Fieldset legend="Select node type">
                <div class="grid">
                    <div class="col-4 flex align-items-center justify-content-center">
                        <Button
                            icon="pi pi-share-alt"
                            class="p-button-rounded p-button-info mr-2"
                            v-tooltip="'Add Connector'"
                            @click="createNodeConnector"
                        />
                    </div>
                    <div class="col-8 flex align-items-center">
                        Add a new Connector
                    </div>
                    <div class="col-4 flex align-items-center justify-content-center">
                        <Button
                            icon="pi pi-cog"
                            class="p-button-rounded p-button-success mr-2"
                            v-tooltip="'Add Procedure'"
                            @click="createNodeProcedure"
                        />
                    </div>
                    <div class="col-8 flex align-items-center">
                        Add a new Procedure
                    </div>
                </div>
            </Fieldset>
        </template>

        <template v-if="step === 3">

            <Fieldset legend="Connector type" v-if="nodeToCreateOrUpdate.type === 'connector'">
                <div class="grid">
                    <div class="form-field col-12 col">
                        <label for="connector-type">Type</label>
                        <Dropdown
                            v-model="nodeToCreateOrUpdate.logical_operation"
                            :options="logicalOperation"
                            optionLabel="name"
                            optionValue="id"
                            placeholder="Select Connector Type" showClear
                        />
                    </div>
                </div>
            </Fieldset>
            <Fieldset legend="Procedure type" v-if="nodeToCreateOrUpdate.type === 'procedure'">
                <Panel header="Warning" class="mb-5">
                    Please note: if the procedure type is changed, its details will be erased.<br />
                    <small v-if="sharable" style="color: rgb(200,0,0)">
                        The <b>Datasource</b> is sharable, some procedure are disabled.
                    </small>
                </Panel>

                <div class="grid">
                    <template v-for="procedure in sortedProcedureList" :key="procedure.code">
                        <div class="col-4">
                            <div class="field-radiobutton">
                                <RadioButton
                                    :id="procedure.code"
                                    :value="procedure.code"
                                    v-model="nodeToCreateOrUpdate.procedure"
                                    @change="onChangeProcedureType"
                                    :disabled="procedureDisabledIfSharable(procedure.code)"
                                />
                                <label :for="procedure.code" class="mx-2">
                                    <span v-if="procedureDisabledIfSharable(procedure.code)">
                                        <b>[Disabled]</b>
                                    </span>
                                    {{procedure.label}}
                                </label>
                            </div>
                        </div>
                        <div class="col-8" v-html="procedure.description" />
                    </template>
                </div>
            </Fieldset>
        </template>

        <template v-if="step === 4">

            <Fieldset legend="Procedure details" v-if="nodeToCreateOrUpdate.procedure === 'assessment_date'">
                <Panel header="Help" class="mb-5">
                    This procedure return the Assessment date (when the Assessment was submitted),
                    then it will be compared, using the logical operator, with the date provided.
                </Panel>

                <div class="grid">
                    <div class="col-6 form-field">
                        <label for="connector-type">Comparison operator</label>
                        <Dropdown
                            v-model="nodeToCreateOrUpdate.operator"
                            :options="procedureOperatorList"
                            optionLabel="desc"
                            optionValue="code"
                            placeholder="Select operator Type"
                            showClear
                            :showWeek="true"
                        />
                    </div>

                    <div class="col-6 form-field">
                        <label for="assessment_date">Selected date</label>
                        <Calendar
                            id="assessment_date"
                            :showIcon="true"
                            :manualInput="true"
                            :showButtonBar="true"
                            dateFormat="dd-mm-yy"
                            v-model="valueAsDate"
                            @date-select="onDateSelected"
                        />
                    </div>

                </div>
            </Fieldset>
            <Fieldset legend="Procedure details" v-else-if="nodeToCreateOrUpdate.procedure === 'user_today_age'">
                <Panel header="Help" class="mb-5">
                    This procedure is based on the User's date of birth declared in the their User Profile.<br />
                    The value must be an integer number greater than 0 (hence the value must be an integer positive
                    number; the lower possible value is 1, the 0 is excluded).<br />
                </Panel>

                <div class="grid">
                    <div class="col-6 form-field">
                        <label for="connector-type">Comparison operator</label>
                        <Dropdown
                            v-model="nodeToCreateOrUpdate.operator"
                            :options="procedureOperatorList"
                            optionLabel="desc"
                            optionValue="code"
                            placeholder="Select operator Type"
                            showClear
                        />
                    </div>
                    <div class="col-6 form-field">
                        <label for="age" class=" align-content-center"> User today age:</label>
                        <InputNumber
                            id="age"
                            v-model="nodeToCreateOrUpdate.value"
                            showButtons
                            buttonLayout="horizontal"
                            :step="1"
                            inputId="age"
                            :min="1"
                            :max="1000"
                            suffix=" years"
                            placeholder="Enter the age in years"
                        />
                    </div>
                </div>

            </Fieldset>
            <Fieldset legend="Procedure details" v-else-if="nodeToCreateOrUpdate.procedure === 'assessment_user_age'">
                <Panel header="Help" class="mb-5">
                    This procedure is based on the User's date of birth declared in the their User Profile.<br />
                    The value must be an integer number greater than 0 (hence the value must be an integer positive
                    number; the lower possible value is 1, the 0 is excluded).<br />
                </Panel>

                <div class="grid">
                    <div class="col-6 form-field">
                        <label for="connector-type">Comparison operator</label>
                        <Dropdown
                            v-model="nodeToCreateOrUpdate.operator"
                            :options="procedureOperatorList"
                            optionLabel="desc"
                            optionValue="code"
                            placeholder="Select operator Type"
                            showClear
                        />
                    </div>
                    <div class="col-6 form-field">
                        <label for="age" class=" align-content-center"> User age (at assessment time):</label>
                        <InputNumber
                            id="age"
                            v-model="nodeToCreateOrUpdate.value"
                            showButtons
                            buttonLayout="horizontal"
                            :step="1"
                            inputId="age"
                            :min="1"
                            :max="1000"
                            suffix=" years"
                            placeholder="Enter the age in years"
                        />
                    </div>
                </div>

            </Fieldset>
            <Fieldset legend="Procedure details" v-else-if="nodeToCreateOrUpdate.procedure === 'assessment_code'">
                <Panel header="Help" class="mb-5">
                    This procedure require that the assessment's code is (based on the operator provided):
                    <ol>
                        <li><b>Equal</b> to the assessment code</li>
                        <li><b>Not equal</b> to the assessment code</li>
                    </ol>
                </Panel>

                <div class="grid">
                    <div class="col-6 form-field">
                        <label for="connector-type">Comparison operator</label>
                        <Dropdown
                            v-model="nodeToCreateOrUpdate.operator"
                            :options="equalOrNotOperatorList"
                            optionLabel="desc"
                            optionValue="code"
                            placeholder="Select operator Type"
                            showClear
                        />
                    </div>
                    <div class="col-6 form-field">
                        <label for="assessmentList" class=" align-content-center"> Assessment:</label>

                        <Dropdown
                            :options="assessmentList"
                            optionLabel="name"
                            v-model="nodeToCreateOrUpdate.value"
                            id="assessmentList"
                            optionValue="code"
                            placeholder="Select Assessment" showClear
                        />
                    </div>
                </div>
            </Fieldset>
            <Fieldset legend="Procedure details" v-else-if="nodeToCreateOrUpdate.procedure === 'without_assessment_code'">
                <Panel header="Help" class="mb-5">
                    This procedure require that the user never completed the given assessment (respecting other
                    conditions like dates constraints).
                </Panel>

                <div class="grid">
                    <div class="col-6 form-field">
                        <label for="assessmentList" class=" align-content-center"> Assessment:</label>

                        <Dropdown
                            filter
                            :options="assessmentList"
                            optionLabel="name"
                            v-model="nodeToCreateOrUpdate.value"
                            id="assessmentList"
                            optionValue="code"
                            placeholder="Select Assessment" showClear
                        />
                    </div>
                </div>
            </Fieldset>
            <Fieldset legend="Procedure details" v-else-if="
                nodeToCreateOrUpdate.procedure === 'attribute' ||
                nodeToCreateOrUpdate.procedure === 'first_attribute' ||
                nodeToCreateOrUpdate.procedure === 'last_attribute'"
            >
                <Panel header="Help" class="mb-5">
                    This procedure filter the results based on the value of the selected attribute.<br />
                    Please note: in case of <b>shared</b> Datasource, only the <b>tag</b> will be available.<br />
                    To select the attribute add:
                    <ul>
                        <li><b>Attribute</b> (optionally with <b>Assessment</b>) <b>OR</b></li>
                        <li><b>Tag</b></li>
                    </ul>
                </Panel>

                <div class="grid">
                    <div :class="nodeToCreateOrUpdate.assessment_code===null && nodeToCreateOrUpdate.attribute_code === null ?  'col-6' : 'col-12'"
                         v-if="nodeToCreateOrUpdate.tag_id===null && !sharable">
                        <Fieldset legend="Standard Attribute">
                            <div class="grid">
                                <div class="col-12 form-field">
                                    <label for="assessmentList" class=" align-content-center"> Assessment: <span style="color: red">*</span></label>
                                    <Dropdown
                                        filter
                                        :options="assessmentList"
                                        optionLabel="name"
                                        v-model="nodeToCreateOrUpdate.assessment_code"
                                        id="assessmentList"
                                        optionValue="code"
                                        placeholder="Select Assessment" showClear
                                        :class="{ 'p-invalid': submitted && !nodeToCreateOrUpdate.value.assessment_code }"
                                    />
                                    <small v-if="submitted && !nodeToCreateOrUpdate.value.assessment_code" class="p-error">
                                        Assessment is required.
                                    </small>
                                </div>
                                <div class="col-12 form-field">
                                    <label for="attributeList" class=" align-content-center"> Attribute:</label>

                                    <Dropdown
                                        filter
                                        :options="attributeListOrdered"
                                        optionLabel="label"
                                        v-model="nodeToCreateOrUpdate.attribute_code"
                                        id="attributeList"
                                        optionValue="code"
                                        placeholder="Select Attribute" showClear
                                    />
                                </div>
                            </div>
                        </Fieldset>
                    </div>
                    <div :class="nodeToCreateOrUpdate.tag_id===null && !sharable ? 'col-6' : 'col-12'" v-if="nodeToCreateOrUpdate.assessment_code===null && nodeToCreateOrUpdate.attribute_code === null">
                        <Fieldset legend="Tag Attribute">
                            <div class="grid">
                                <div class="col-12 form-field">
                                    <label for="assessmentList" class=" align-content-center"> Tag:</label>
                                    <Dropdown
                                        :disabled="nodeToCreateOrUpdate.attribute_code!==null || nodeToCreateOrUpdate.assessment_code!==null"
                                        filter
                                        :options="tagListOrdered"
                                        optionLabel="label"
                                        v-model="nodeToCreateOrUpdate.tag_id"
                                        id="assessmentList"
                                        optionValue="id"
                                        placeholder="Select Tag" showClear
                                    />
                                </div>
                            </div>
                        </Fieldset>
                    </div>

                    <div class="col-12">
                        <Fieldset legend="Configuration">

                            <div class="grid">
                                <div class="col-6 form-field">
                                    <label for="connector-type">Comparison operator</label>
                                    <Dropdown
                                        v-model="nodeToCreateOrUpdate.operator"
                                        :options="procedureOperatorList"
                                        optionLabel="desc"
                                        optionValue="code"
                                        placeholder="Select operator Type"
                                        showClear
                                    />
                                </div>



                                <div class="col-6 form-field" v-if="attributeOptionList.length > 0">
                                    <label for="connector-type">Value</label>
                                    <Dropdown
                                        v-model="nodeToCreateOrUpdate.value"
                                        :options="attributeOptionList"
                                        optionLabel="label"
                                        optionValue="value"
                                        placeholder="Select Value"
                                        showClear
                                        v-if="selectedAttribute?.type !== '7'"
                                    />
                                    <Calendar
                                        v-if="selectedAttribute?.type === '7'"
                                        :showIcon="true"
                                        v-model="nodeToCreateOrUpdate.value"
                                        dateFormat="dd-mm-yy"
                                    />
                                </div>
                                <div class="col-6 form-field" v-if="attributeOptionList.length === 0">
                                    <label>Value</label>
                                    <InputNumber
                                        v-if="selectedAttribute?.type !== '7'"
                                        v-model="nodeToCreateOrUpdate.value"
                                        placeholder="Enter Value"
                                        :useGrouping=false
                                        :minFractionDigits=0
                                        :maxFractionDigits=2
                                    />
                                    <!-- v-model="nodeToCreateOrUpdate.value" -->
                                    <Calendar
                                        v-if="selectedAttribute?.type === '7'"
                                        :showIcon="true"
                                        v-model="nodeToCreateOrUpdate.value"
                                        dateFormat="dd-mm-yy"
                                    />
                                </div>
                            </div>
                        </Fieldset>
                    </div>
                </div>
            </Fieldset>
            <Fieldset legend="Procedure details" v-else-if="nodeToCreateOrUpdate.procedure === 'user_profile'">
                <Panel header="Help" class="mb-5">
                    Must be or must not be a User Profile
                </Panel>

                <div class="grid">
                    <div class="col-6 form-field">
                        <label for="connector-type">User profile?</label>

                        <Dropdown
                            v-model="nodeToCreateOrUpdate.value"
                            :options="[{label: 'Yes', value: 1}, {label: 'No', value: 0}]"
                            optionLabel="label"
                            optionValue="value"
                            placeholder="Select User Profile Yes/No"
                            showClear
                            :showWeek="true"
                        />
                    </div>
                    <div class="col-6 flex align-items-center flex-wrap text-l">
                        <div class=" align-items-center justify-content-center" v-if="nodeToCreateOrUpdate.value === 1">The Assessment must be a <Tag severity="success" value="User profile"></Tag></div>
                        <div class=" align-items-center justify-content-center" v-if="nodeToCreateOrUpdate.value === 0">The Assessment must not be a <Tag severity="danger" value="User profile"></Tag></div>

                    </div>

                </div>
            </Fieldset>
            <Fieldset legend="Procedure details" v-else-if="nodeToCreateOrUpdate.procedure === 'pass_fail'">
                <Panel header="Help" class="mb-5">
                    This Procedure aim is to filter out all the Assessment Form that resulted in a Pass or in a Fail.
                    There is no Assessment code: the only target is the form result.
                    Used alone it will only filter assessments based on the result (including also User Profiles).
                    So, it's strongly suggested to use it together with other Procedures to restrict the result-set.
                </Panel>

                <div class="grid">
                    <div class="col-6 form-field">
                        <label for="connector-type">Result:</label>

                        <Dropdown
                            v-model="nodeToCreateOrUpdate.value"
                            :options="[{label: 'Pass', value: '1'}, {label: 'Fail', value: '0'}]"
                            optionLabel="label"
                            optionValue="value"
                            placeholder="Select Pass or Fail"
                            showClear
                            :showWeek="true"
                        />
                    </div>
                    <div class="col-6 flex align-items-center flex-wrap text-xl">
                        <div class=" align-items-center justify-content-center" v-if="nodeToCreateOrUpdate.value === '1'">The Assessment must end in a <Tag severity="success" value="Pass">Pass</Tag></div>
                        <div class=" align-items-center justify-content-center" v-if="nodeToCreateOrUpdate.value === '0'">The Assessment must end in a <Tag severity="danger" value="Fail">Fail</Tag></div>

                    </div>

                </div>
            </Fieldset>
            <Fieldset legend="Procedure details" v-else-if="nodeToCreateOrUpdate.procedure === 'active_only_assessment'">
                <Panel header="Help" class="mb-5">
                    By default, old forms that use old and deleted Assessment are always available.
                    This procedure is created to limit this behavior.
                </Panel>

                <div class="grid">
                    <div class="col-6 form-field">
                        <label for="connector-type">Should it be active</label>

                        <Dropdown
                            v-model="nodeToCreateOrUpdate.value"
                            :options="[{label: 'Yes', value: '1'}, {label: 'No', value: '0'}]"
                            optionLabel="label"
                            optionValue="value"
                            placeholder="Select Yes / No"
                            showClear
                            :showWeek="true"
                        />
                    </div>
                    <div class="col-6 flex align-items-center flex-wrap text-xl">
                        <div class=" align-items-center justify-content-center" v-if="nodeToCreateOrUpdate.value === '1'">The Assessment must be <Tag severity="success" value="Active"></Tag></div>
                        <div class=" align-items-center justify-content-center" v-if="nodeToCreateOrUpdate.value === '0'">The Assessment must be <Tag severity="danger" value="Inactive"></Tag></div>

                    </div>

                </div>
            </Fieldset>
            <Fieldset legend="Procedure details" v-else-if="nodeToCreateOrUpdate.procedure === 'active_only_attribute'">
                <Panel header="Help" class="mb-5">
                    By default, old forms that use old and deleted Attributes are always available.
                    This procedure is created to limit this behavior.
                </Panel>

                <div class="grid">
                    <div class="col-6 form-field">
                        <label for="connector-type">Should it be active</label>

                        <Dropdown
                            v-model="nodeToCreateOrUpdate.value"
                            :options="[{label: 'Yes', value: '1'}, {label: 'No', value: '0'}]"
                            optionLabel="label"
                            optionValue="value"
                            placeholder="Select Yes / No"
                            showClear
                            :showWeek="true"
                        />
                    </div>
                    <div class="col-6 flex align-items-center flex-wrap text-xl">
                        <div class=" align-items-center justify-content-center" v-if="nodeToCreateOrUpdate.value === '1'">The Attribute must be <Tag severity="success" value="Active"></Tag></div>
                        <div class=" align-items-center justify-content-center" v-if="nodeToCreateOrUpdate.value === '0'">The Attribute must be <Tag severity="danger" value="Inactive"></Tag></div>

                    </div>

                </div>
            </Fieldset>
            <Fieldset legend="Procedure details" v-else-if="nodeToCreateOrUpdate.procedure === 'user_list'">
                <Panel header="Help" class="mb-5">
                    Please select User either by Name, Surname or email.<br />
                    The procedure will limit the submitted form to the one submitted for those Users.
                </Panel>

                <div class="col-12" v-if="selectedUserList && selectedUserList.length > 0">
                    <div class="flex flex-wrap gap-2">
                        <Chip v-for="selectedUser in selectedUserList" :key="selectedUser.id" :label="selectedUser.name+' '+selectedUser.surname" removable @remove="removeSelectedUser(selectedUser)" />
                    </div>
                </div>

                <div class="grid">
                    <div class="col-3 form-field">
                        <label for="name">Name</label>
                        <InputText maxlength = "255" id="name" v-model="userListFilterName" placeholder="Name"/>
                    </div>
                    <div class="col-4 form-field">
                        <label for="surname">Surname</label>
                        <InputText maxlength = "255" id="surname" v-model="userListFilterSurname" placeholder="Surname"/>
                    </div>
                    <div class="col-4 form-field">
                        <label for="email">Surname</label>
                        <InputText maxlength = "255" id="email" v-model="userListFilterEmail" placeholder="Email"/>
                    </div>
                    <div class="col-1">
                        <label for="filter">Filter</label>
                        <Button
                            id="filter"
                            icon="pi pi-filter"
                            class="p-button-rounded mr-2"
                            severity="info"
                            raised
                            tooltip="Filter user list"
                            @click="onChangeUserFilters"
                        />
                    </div>

                    <div class="col-12">

                        <DataTable
                            v-model:selection="selectedUsers"
                            :lazy="true"
                            :value="usersList"
                            :resizableColumns="true"
                            ref="dt"
                            data-key="id"
                            :rowHover="true"
                            paginator
                            :rows="10"
                            :loading="usersListLoading"
                            :totalRecords="usersListTotal"
                            responsiveLayout="scroll"
                            paginatorTemplate="CurrentPageReport JumpToPageInput FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            @page="onUserListPage"
                            @row-select-all="onUserRowSelectedAll"
                            @row-unselect-all="onUserRowUnselectedAll"
                            @row-select="onUserRowSelect"
                            @row-unselect="onUserRowUnselect"
                        >
                            <template #empty>No Users available.</template>
                            <template #loading>Loading DataSources. Please wait.</template>

                            <Column selectionMode="multiple" style="max-width: 4rem" />
                            <Column field="name" header="Name" style="max-width: 14rem" />
                            <Column field="surname" header="Surname" style="max-width: 14rem" />
                            <Column field="email" header="Email" style="max-width: 14rem" />
                        </DataTable>
                    </div>
                </div>
            </Fieldset>
            <!-- new changes -->
            <Fieldset legend="Procedure details" v-else-if="nodeToCreateOrUpdate.procedure === 'archive_status'">
                <Panel header="Help" class="mb-5">
                    This Procedure aim is to filter out archive users status
                </Panel>

                <div class="grid">
                    <div class="col-6 form-field">
                        <label for="connector-type">Result:</label>

                        <Dropdown v-model="nodeToCreateOrUpdate.value"
                            :options="[ { value: 1, label: 'Include all' }, { value: 2, label: 'Exclude archived (Active only)' }, { value: 3, label: 'Archived only' }]"
                            optionLabel="label" optionValue="value" placeholder="Select Archive user status" showClear
                            :showWeek="true" />
                    </div>
                    <div class="col-6 flex align-items-center flex-wrap text-xl">
                        <div v-if="nodeToCreateOrUpdate.value === 1">
                            <Tag severity="success" value="All users" />
                        </div>
                        <div v-if="nodeToCreateOrUpdate.value === 2">
                            <Tag severity="success" value="Active users only" />
                        </div>
                        <div v-else-if="nodeToCreateOrUpdate.value === 3">
                            <Tag severity="warning" value="Archived users only" />
                        </div>
                    </div>

                </div>
            </Fieldset>
            <!-- new changes -->
        </template>

        <template #footer>
            <div class="flex flex-1 justify-content-end">

                <div class="flex flex-1 justify-content-start">
                    Step: {{step}}
                </div>

                <Button
                    v-if="nodeToCreateOrUpdate.type === 'connector' && step === 3"
                    class="mr-2 p-button p-button-success"
                    :disabled="saving"
                    type="button"
                    icon="pi pi-save"
                    label="Save"
                    :loading="saving"
                    @click="saveNode"
                />

                <Button
                    v-if="step === 4"
                    class="mr-2 p-button p-button-info"
                    :disabled="saving"
                    type="button"
                    icon="pi pi-arrow-left"
                    label="Back"
                    :loading="saving"
                    @click="backToProcedures"
                />

                <Button
                    v-if="step === 4"
                    class="mr-2 p-button p-button-success"
                    :disabled="saving || !isValid"
                    type="button"
                    icon="pi pi-save"
                    label="Save"
                    :loading="saving"
                    @click="saveNode"
                />

                <Button
                    v-if="nodeToCreateOrUpdate.type !== 'connector' && step === 3"
                    class="mr-2 p-button p-button-info"
                    :disabled="saving"
                    type="button"
                    icon="pi pi-arrow-right"
                    label="Next"
                    :loading="saving"
                    @click="editProperties"
                />

                <Button
                    v-if="nodeData.type === 'connector' && step === 1"
                    class="mr-2 p-button p-button-info"
                    :disabled="saving || nodeData.type === 'procedure'"
                    type="button"
                    icon="pi pi-plus"
                    label="Add children"
                    :loading="saving"
                    @click="addChildren"
                    :badge="nodeData.children ? nodeData.children.length.toString() : '0'"
                />
                <Button
                    v-if="step === 1"
                    class="mr-2 p-button p-button-success"
                    :disabled="saving || step1UserLoading"
                    type="button"
                    icon="pi pi-pencil"
                    label="Edit"
                    :loading="saving"
                    @click="editNode"
                />

                <Button
                    v-if="step === 1"
                    class="mr-2 p-button p-button-danger"
                    :disabled="saving || !nodeData.parent"
                    type="button"
                    icon="pi pi-trash"
                    label="Delete"
                    :loading="saving"
                    @click="onDeleteNode"
                />
                <Button
                    class="p-button p-button-warning"
                    type="button"
                    icon="pi pi-times"
                    label="Cancel"
                    @click="onHideDialog"
                />
            </div>
        </template>
    </Dialog>
</template>

<script setup>
import { computed, defineEmits, defineProps, onMounted, ref, watch, watchEffect } from 'vue';
import { DateTime } from 'luxon';
import GlobalRequest from '@/api/global-request';
import useUserComposable from '@/composables/UserComposable';
//import { DateTime } from 'luxon';

const { company_id } = useUserComposable();

const props = defineProps({
    showEditDialog: {
        type: Boolean,
        required: true
    },
    nodeSelected: {
        type: Object,
        required: false,
    },
    saving: {
        type: Boolean,
        required: false
    },
    attributeList: {
        type: Array,
        required: false
    },
    assessmentList: {
        type: Array,
        required: false
    },
    tagList: {
        type: Array,
        required: false
    },
    sharable: {
        type: Boolean,
        required: false
    }
})

const emit = defineEmits(['onDeleteNode', 'onHideNodeEditDialog', 'onCreateUpdateNode']);

const showDialog = ref(false)
const nodeData = ref({})
const nodeToCreateOrUpdate = ref({})

const step = ref(0)

const procedureOperatorList = ref([
    {
        code: '==',
        desc: 'Equal to',
    },
    {
        code: '!=',
        desc: 'Not equal to',
    },
    {
        code: '>=',
        desc: 'Greater than or equal to',
    },
    {
        code: '<=',
        desc: 'Less than or equal to',
    },
    {
        code: '>',
        desc: 'Greater than',
    },
    {
        code: '<',
        desc: 'Less than',
    },
])

const equalOrNotOperatorList = ref([
    {
        code: '==',
        desc: 'Equal to',
    },
    {
        code: '!=',
        desc: 'Not equal to',
    },
])

const logicalOperation = [
    {
        id: 'AND',
        name: 'AND',
    },
    {
        id: 'OR',
        name: 'OR',
    },
    {
        id: 'NOT',
        name: 'NOT',
    },
]

const procedureList = ref([
    {
        code: 'user_today_age',
        label: 'Today User age',
        description: 'Return the age of user as today based on user_dob in the last user profile',
    },
    {
        code: 'assessment_date',
        label: 'Assessment Date',
        description: 'Assessment Date',
    },
    {
        code: 'assessment_user_age',
        label: 'Assessment User age',
        description: 'Return the age of the user that submitted the form at submission time',
    },
    {
        code: 'assessment_code',
        label: 'Assessment Code',
        description: 'Assessment unique identifier',
    },
    {
        code: 'without_assessment_code',
        label: 'Without Assessment Code',
        description: 'Return Users without the given assessment',
    },
    {
        code: 'attribute',
        label: 'Attribute',
        description: 'Return the attribute value',
    },
    {
        code: 'first_attribute',
        label: 'First Attribute',
        description: `Return true only if the first assessment met the conditions (<b>Suitable ONLY for User Groups</b>)`,
    },
    {
        code: 'last_attribute',
        label: 'Last Attribute',
        description: `Return true only if the last assessment met the conditions (<b>Suitable ONLY for User Groups</b>)`,
    },
    {
        code: 'pass_fail',
        label: 'Pass or Fail',
        description: 'Return true if the assessment is success, false if it\'s fail',
    },
    {
        code: 'user_profile',
        label: 'User profile',
        description: 'Exclude the User Profile',
    },
    {
        code: 'user_list',
        label: 'User list',
        description: 'Include only assessments done by the nominated users',
    },
    {
        code: 'active_only_assessment',
        label: 'Active assessments',
        description: 'Include or exclude inactive assessments',
    },
    {
        code: 'active_only_attribute',
        label: 'Active attributes',
        description: 'Include or exclude inactive attributes',
    },
    {
        code: 'archive_status',
        label: 'Archive Status',
        description: 'Inclue user archive status',
    },
])

const attributeListOrdered = computed(() => {

    let ordered = []

    props.attributeList.forEach((item) => {
        ordered.push({
            id: item.id,
            label: item.label.substr(0, 50)+" | " + item.code,
            code: item.code,
            type: item.type,
            options: item.options,
        })
    })

    ordered = ordered.sort((a,b) => {
        if (a.label.toLowerCase() < b.label.toLowerCase()) return -1;
        if (a.label.toLowerCase() > b.label.toLowerCase()) return 1;
        return 0
    })

    return ordered
})

const selectedAttribute = computed(() => {
    let foundItem = null

    if (nodeToCreateOrUpdate.value.attribute_code !== null) {
        attributeListOrdered.value.forEach((item) => {

            if (item.code === nodeToCreateOrUpdate.value.attribute_code) {
                foundItem = item
                // console.log('foundItem', foundItem)
            }
        })
    } else {
        tagListOrdered.value.forEach((item) => {
            //console.log('item', item)

            if (item.id === nodeToCreateOrUpdate.value.tag_id) {
                foundItem = item.attribute
                foundItem.tag_id = item.id
                // console.log('foundItem', foundItem)
            }
        })
    }

    return foundItem
})

watch(selectedAttribute, () => {
    // console.log('selectedAttribute', selectedAttribute.value)

    if (selectedAttribute?.value?.type === '7' && nodeToCreateOrUpdate.value.value == null) {
        nodeToCreateOrUpdate.value.value = DateTime.now().toJSDate()
    }
});

const attributeOptionList = computed(() => {
    let attribute = null

    if (nodeToCreateOrUpdate.value.tag_id !== null && parseInt(nodeToCreateOrUpdate.value.tag_id) > 0) {
        const tag = props.tagList.find(tag => tag.id === nodeToCreateOrUpdate.value.tag_id)

        if (Object.hasOwn(tag, 'attribute')) {
            attribute = tag.attribute

            if (Object.hasOwn(attribute, 'options')) {
                return attribute.options
            }
        }
    } else if (nodeToCreateOrUpdate.value.attribute_code !== null && nodeToCreateOrUpdate.value.attribute_code.length > 0) {
        attribute = props.attributeList.find(attribute => attribute.code === nodeToCreateOrUpdate.value.attribute_code)

        if (Object.hasOwn(attribute, 'options')) {
            return attribute.options
        }
    }

    return []
})

const tagListOrdered = computed(() => {

    let ordered = []

    props.tagList.forEach((item) => {
        ordered.push({
            id: item.id,
            label: item.description.substr(0, 50)+" | " + item.code+" | " + item.id,
            code: item.code,
            attribute: item.attribute,
        })
    })

    ordered = ordered.sort((a,b) => {
        if (a.label.toLowerCase() < b.label.toLowerCase()) return -1;
        if (a.label.toLowerCase() > b.label.toLowerCase()) return 1;
        return 0
    })

    return ordered
})

const valueAsDate = computed({
    get() {
        if (nodeToCreateOrUpdate.value.value instanceof DateTime) {
            return nodeToCreateOrUpdate.value.value.setLocale('en-GB').toJSDate()
        }
        return null
    },
    set(newDate) {
        if (newDate instanceof Date) {
            nodeToCreateOrUpdate.value.value = DateTime.fromJSDate(newDate)
        } else {
            nodeToCreateOrUpdate.value.value = null
        }
    }
})

//const sortedProcedureList = computed(() => procedureList.value.slice().sort((a, b) => a.label.localeCompare(b.label)));
const sortedProcedureList =  procedureList.value

const isValid = computed(() => {
    let output = false

    switch (nodeToCreateOrUpdate.value.procedure) {
        case 'user_today_age':
        case 'assessment_user_age':
            if (nodeToCreateOrUpdate.value.value !== null && nodeToCreateOrUpdate.value.value > 0 && nodeToCreateOrUpdate.value.operator !== null) {
                output = true
            }
            break
        case 'assessment_date':
        case 'assessment_code':
            if (nodeToCreateOrUpdate.value.value !== null && nodeToCreateOrUpdate.value.operator !== null) {
                output = true
            }
            break
        case 'without_assessment_code':
        case 'user_profile':
        case 'active_only_assessment':
        case 'active_only_attribute':
        case 'pass_fail':
        case 'user_list':
        case 'archive_status':
            if (nodeToCreateOrUpdate.value.value !== null) {
                output = true
            }
            break
        case 'attribute':
        case 'first_attribute':
        case 'last_attribute':
            if (nodeToCreateOrUpdate.value.value !== null && nodeToCreateOrUpdate.value.value > 0 && nodeToCreateOrUpdate.value.operator !== null) {

                if (nodeToCreateOrUpdate.value.attribute_code || nodeToCreateOrUpdate.value.tag_id !== null) {
                    output = true
                }
            }
            break

    }

    return output
});

const userListFilterName = ref('')
const userListFilterSurname = ref('')
const userListFilterEmail = ref('')
const usersList = ref([])
const usersListLoading = ref(false)
const usersListTotal = ref(0)
const usersListPaginationPage = ref(0)
const selectedUsers = ref([])

const selectedUserList = ref([])

const step1userList = ref([])
const step1UserLoading = ref(false)

const submitted = ref(false);

onMounted(() => {
    loadUsers()
})

function onChangeUserFilters() {
    loadUsers(userListFilterName.value, userListFilterSurname.value, userListFilterEmail.value)
}

function onUserListPage(event) {
    //Table data pages start with 0 not with 1.
    usersListPaginationPage.value = event.page + 1;

    onChangeUserFilters();
}

function loadUsers(name, surname, email) {
    usersList.value = []
    usersListLoading.value = true

    let params = {
        company_id: company_id.value,
        page_size: 10,
        page: usersListPaginationPage.value,
    }

    if (name !== null && typeof name !== 'undefined' && name.length > 0) {
        params.name = name
    }
    if (surname !== null && typeof surname !== 'undefined' && surname.length > 0) {
        params.surname = surname
    }
    if (email !== null && typeof email !== 'undefined' && email.length > 0) {
        params.email = email
    }

    return GlobalRequest.getRequest(`/v2/admin/users`, {
        params: params
    }).then((response) => {
        if (response.statusCode === 200) {
            if (Object.hasOwn(response, 'data')) {
                if (Object.hasOwn(response.data, 'data')) {
                    usersList.value = response.data.data
                    usersListTotal.value = response.data.total

                    usersListLoading.value = false

                    // Restore the user's selection after page change
                    selectedUsers.value = selectedUserList.value
                }
            }
        }
    })
}

// Chip - user remove
function removeSelectedUser(unselectedUser) {
    selectedUsers.value = selectedUsers.value.filter((item) => item.id !== unselectedUser.id)
}

function onUserRowSelectedAll(event) {
    if (Object.hasOwn(event, 'data') && Array.isArray(event.data)) {
        event.data.forEach((user) => {
            if (!selectedUserList.value.find((item) => item.id === user.id)) {
                selectedUserList.value.push(user)
            }
        })
    }
}

function onUserRowUnselectedAll() {
    usersList.value.forEach((user) => {
        selectedUserList.value = selectedUserList.value.filter((item) => item.id !== user.id)
    })
}

// User list - user added by checkbox
function onUserRowSelect(event) {
    if (Object.hasOwn(event, 'data')) {
        selectedUserList.value.push({
            id: event.data.id,
            name: event.data.name,
            surname: event.data.name,
            email: event.data.email,
        })
    }
}

// User list - user removed by checkbox
function onUserRowUnselect(event) {
    selectedUserList.value = selectedUserList.value.filter((item) => item.id !== event.data.id)
}

watchEffect(() => {
    if (nodeToCreateOrUpdate.value.procedure && nodeToCreateOrUpdate.value.procedure === 'user_list') {


        nodeToCreateOrUpdate.value.value = []

        selectedUserList.value.forEach((item) => {
            nodeToCreateOrUpdate.value.value.push(item.id)
        })
    }
})

watch(() => props.showEditDialog, (show) => {
    step.value = 1
    showDialog.value = show
    nodeData.value = props.nodeSelected
    nodeToCreateOrUpdate.value = {}

    selectedUserList.value = []
    selectedUsers.value = []
    step1userList.value = []

    if (props.nodeSelected.details && props.nodeSelected.details.procedure === 'user_list') {
        loadSelectedUsersByIds(props.nodeSelected.details.value)
    }
})

function loadSelectedUsersByIds(ids) {
    step1UserLoading.value = true

    if (typeof ids === 'string') {
        try {
            ids = JSON.parse(ids)
        } catch (e) {
            console.error('e', e)
            ids = []
        }
    }

    let params = {
        company_id: company_id.value,
        page_size: ids.length,
        ids: ids,
        page: 1,
    }

    GlobalRequest.getRequest(`/v2/admin/users`, {
        params: params,
        paramsSerializer: {
            indexes: true, // use brackets with indexes
        }
    }).then((response) => {
        if (response.statusCode === 200) {
            if (Object.hasOwn(response, 'data')) {
                if (Object.hasOwn(response.data, 'data')) {
                    step1UserLoading.value = false

                    step1userList.value = response.data.data
                    selectedUserList.value = response.data.data
                    selectedUsers.value = response.data.data
                }
            }
        }
    })
}

function procedureDisabledIfSharable(procedure) {
    const nonSharedProcedure = [
        'assessment_code',
        'first_attribute',
        'last_attribute',
        'user_list',
        'without_assessment_code',
    ]

    if (props.sharable) {
        if (nonSharedProcedure.includes(procedure)) {
            return true
        }
    }

    return false
}

function dateFormat(date) {
    if (date instanceof DateTime) {
        // after loading
        return date.setLocale('en-GB').toLocaleString({
            weekday: 'short',
            month: 'short',
            day: '2-digit',
            year: 'numeric',
        })
    } else {
        // during saving process:
        // String 2024-06-18

        return DateTime.fromFormat(date, 'y-LL-dd').setLocale('en-GB').toLocaleString({
            weekday: 'short',
            month: 'short',
            day: '2-digit',
            year: 'numeric',
        })
    }
}

function onChangeProcedureType() {
    nodeToCreateOrUpdate.value.logical_operation = null
    nodeToCreateOrUpdate.value.tag_id = null
    nodeToCreateOrUpdate.value.assessment_code = null
    nodeToCreateOrUpdate.value.attribute_code = null
    nodeToCreateOrUpdate.value.operator = null
    nodeToCreateOrUpdate.value.value = null
    nodeToCreateOrUpdate.value.links = null
}

function getAttributeByCode(code) {
    const obj = props.attributeList.find(attribute => attribute.code === code);

    if (typeof obj !== 'undefined') {
        return obj
    } else {
        return null
    }
}

function getAttributeValueFromCode(attribute_code, value) {

    if ( props.attributeList &&  props.attributeList) {
        const attribute = props.attributeList.find((item) => {
            return item.code == attribute_code
        })

        if ( attribute &&  attribute.options) {
            const Attributeoption =  attribute.options.find((option) => {
                return option.value == value
            })

            if (Attributeoption) {
                return Attributeoption.label
            } else {
                return value
            }
        } else {
            return value
        }
    }
}

function translateOperator(operatorString) {
    let output = ''

    switch (operatorString) {
        case '==':
            output = 'equal to'
            break;
        case '>':
            output = 'greater than'
            break;
        case '>=':
            output = 'greater than or equal to'
            break;
        case '<':
            output = 'less than'
            break;
        case '<=':
            output = 'less than or equal to'
            break;
        case '!=':
            output = 'not equal to'
            break;
    }

    return output
}

function onHideDialog() {
    showDialog.value = false
    emit('onHideNodeEditDialog')
}

function onDeleteNode() {
    emit('onDeleteNode', nodeData.value.details)
}

function addChildren() {
    step.value = 2
}

function createNodeConnector() {
    step.value = 3

    nodeToCreateOrUpdate.value = {
        parent: nodeData.value.details.id,
        type: 'connector',
        logical_operation: null,
        links: [],
    }
}

function createNodeProcedure() {
    step.value = 3

    nodeToCreateOrUpdate.value = {
        parent: nodeData.value.details.id,
        type: 'procedure',
        value: null,
        operator: null,
        procedure: null,
        links: [],
    }
}

function editNode() {
    step.value = 3

    /*
    Cloning original object. If the assign operator is used, it copies the object by references.
    Even if the User closes the popup, the data are changed.
     */
    nodeToCreateOrUpdate.value = { ...nodeData.value.details }


    if (nodeToCreateOrUpdate.value.procedure === 'user_today_age') {
        nodeToCreateOrUpdate.value.value = Number(nodeToCreateOrUpdate.value.value)
    } else if (nodeToCreateOrUpdate.value.procedure === 'assessment_user_age') {
        nodeToCreateOrUpdate.value.value = Number(nodeToCreateOrUpdate.value.value)
    } else if (nodeToCreateOrUpdate.value.procedure === 'first_attribute') {

        if (selectedAttribute?.value?.type !== '7') {
            nodeToCreateOrUpdate.value.value = Number(nodeToCreateOrUpdate.value.value)
        } else {
            nodeToCreateOrUpdate.value.value = DateTime.fromISO(nodeToCreateOrUpdate.value.value).setLocale('en-GB').toFormat('dd-MM-yyyy')
        }

    } else if (nodeToCreateOrUpdate.value.procedure === 'last_attribute') {

        if (selectedAttribute?.value?.type !== '7') {
            nodeToCreateOrUpdate.value.value = Number(nodeToCreateOrUpdate.value.value)
        } else {
            nodeToCreateOrUpdate.value.value = DateTime.fromISO(nodeToCreateOrUpdate.value.value).setLocale('en-GB').toFormat('dd-MM-yyyy')
        }

    } else if (nodeToCreateOrUpdate.value.procedure === 'attribute') {

        if (selectedAttribute?.value?.type !== '7') {
            nodeToCreateOrUpdate.value.value = Number(nodeToCreateOrUpdate.value.value)
        } else {
            nodeToCreateOrUpdate.value.value = DateTime.fromISO(nodeToCreateOrUpdate.value.value).setLocale('en-GB').toFormat('dd-MM-yyyy')
        }

    } else if (nodeToCreateOrUpdate.value.procedure === 'user_profile') {
        nodeToCreateOrUpdate.value.value = Number(nodeToCreateOrUpdate.value.value)
    }
}

function backToProcedures() {
    step.value = 3
}

function editProperties() {
    step.value = 4
}

function saveNode() {
    submitted.value = true;
    // Only validate assessment_code for procedures that require it
    if (nodeToCreateOrUpdate.value.procedure === 'attribute' || 
        nodeToCreateOrUpdate.value.procedure === 'first_attribute' || 
        nodeToCreateOrUpdate.value.procedure === 'last_attribute') {
        
        // Check if we're using a tag or an assessment code
        if (!nodeToCreateOrUpdate.value.tag_id && !nodeToCreateOrUpdate.value.assessment_code) {
            console.log('Please enter either a Tag or an Assessment code');
            return; // prevent saving
        }
    }
    
    submitted.value = false;
    emit('onCreateUpdateNode', nodeToCreateOrUpdate.value);
}

function onDateSelected(date) {
    nodeToCreateOrUpdate.value.value = DateTime.fromJSDate(date)
}

</script>

<style scoped lang="scss">

.form-field {
    display: flex;
    flex-direction: column;
    margin-bottom: 1rem;
}

.form-field label {
    margin-bottom: 0.5rem;
}

</style>